import Enum from "../../../../../../enums/Enum";

const DescriptionEnum = new Enum({
    UNKNOWN: {name: "Unknown"},
    CONSTANT: {name: "Constant"},
    REPETITIVE: {name: "Repetitive"},
    MOVEMENT: {name: "Movement"}
});

export default DescriptionEnum;